var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "image-btn"
  }, [_vm.icon && !_vm.hideTooltip ? _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "color": "primary",
            "icon": ""
          },
          on: {
            "click": _vm.selectFile
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-image-plus")])], 1)];
      }
    }], null, false, 1133156089)
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('imagecropper_add_a_picture')))])]) : _vm._e(), _vm.hideTooltip ? _c('div', {
    staticClass: "d-flex flex-column justify-center align-center cursor-pointer"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "icon": "",
      "x-large": ""
    },
    on: {
      "click": _vm.selectFile
    }
  }, [_c('v-icon', [_vm._v("mdi-image-plus")])], 1), _c('span', {
    staticClass: "branding-label"
  }, [_vm._v(_vm._s(_vm.$t('imagecropper_upload_image')))])], 1) : _vm._e(), !_vm.icon && !_vm.hideTooltip ? _c('v-btn', {
    class: 'inset',
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.selectFile
    }
  }, [_vm._v(_vm._s(_vm.$t('imagecropper_upload_image')))]) : _vm._e(), _c('input', {
    ref: "input-".concat(_vm.inputKey),
    attrs: {
      "id": _vm.inputKey,
      "type": "file",
      "name": "image",
      "accept": "image/*"
    },
    on: {
      "change": _vm.setImage
    }
  }), _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "width": "700"
    },
    model: {
      value: _vm.openModal,
      callback: function callback($$v) {
        _vm.openModal = $$v;
      },
      expression: "openModal"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.$t('imagecropper_image_upload')))]), _c('v-card-text', [_c('vue-cropper', {
    ref: "cropper-".concat(_vm.inputKey),
    attrs: {
      "src": this.src,
      "viewMode": 1,
      "containerStyle": _vm.containerStyle,
      "zoomable": false
    }
  })], 1), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": "",
      "disabled": _vm.uploading
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v(_vm._s(_vm.$t('close')))]), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary",
      "loading": _vm.uploading
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t('save')))])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }